import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-podcast-list',
  templateUrl: './podcast-list.component.html',
  styleUrls: ['./podcast-list.component.scss']
})
export class PodcastListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


    appsUrl = environment.CMS_APPS_URL;
    signUrl = environment.WEB_URL;
    searchText = '';

    searchPodcasts() {
      
    }

    podcasts = [
      {
        "id": 1,
        "presenter": "Alexandra Zatarain",
        "title": "Become an Amy Agency – Connect with Global Clients and Win More Projects",
        "duration": "50 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
        "videoUrl": "https://example.com/video1"
      },
      {
        "id": 2,
        "presenter": "John Doe",
        "title": "Mastering Remote Work Strategies",
        "duration": "45 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
        "videoUrl": "https://example.com/video2"
      },
      {
        "id": 3,
        "presenter": "Jane Smith",
        "title": "Boost Your Productivity with Proven Techniques",
        "duration": "30 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
        "videoUrl": "https://example.com/video3"
      },
      {
        "id": 4,
        "presenter": "Michael Brown",
        "title": "Building Effective Client Relationships",
        "duration": "40 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
        "videoUrl": "https://example.com/video4"
      },
      {
        "id": 5,
        "presenter": "Emily Johnson",
        "title": "Breaking Barriers in Global Marketing",
        "duration": "55 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
        "videoUrl": "https://example.com/video5"
      },
      {
        "id": 6,
        "presenter": "Chris Green",
        "title": "Innovation in Technology: Trends and Insights",
        "duration": "60 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
        "videoUrl": "https://example.com/video6"
      },
      {
        "id": 7,
        "presenter": "Sophia White",
        "title": "Enhancing Leadership Skills",
        "duration": "35 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
        "videoUrl": "https://example.com/video7"
      },
      {
        "id": 8,
        "presenter": "David Wilson",
        "title": "Effective Time Management Tips",
        "duration": "25 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
        "videoUrl": "https://example.com/video8"
      },
      {
        "id": 9,
        "presenter": "Olivia Martin",
        "title": "Creative Problem-Solving Strategies",
        "duration": "50 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
        "videoUrl": "https://example.com/video9"
      },
      {
        "id": 10,
        "presenter": "Daniel King",
        "title": "Secrets to Entrepreneurial Success",
        "duration": "45 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
        "videoUrl": "https://example.com/video10"
      },
      {
        "id": 11,
        "presenter": "Isabella Scott",
        "title": "Data-Driven Marketing Strategies",
        "duration": "30 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
        "videoUrl": "https://example.com/video11"
      },
      {
        "id": 12,
        "presenter": "Elijah Adams",
        "title": "Maximizing ROI with Digital Campaigns",
        "duration": "40 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
        "videoUrl": "https://example.com/video12"
      },
      {
        "id": 13,
        "presenter": "Amelia Moore",
        "title": "Building Resilience in a Fast-Paced World",
        "duration": "55 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
        "videoUrl": "https://example.com/video13"
      },
      {
        "id": 14,
        "presenter": "Lucas Brown",
        "title": "Future Trends in Artificial Intelligence",
        "duration": "60 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
        "videoUrl": "https://example.com/video14"
      },
      {
        "id": 15,
        "presenter": "Mia Garcia",
        "title": "The Art of Negotiation",
        "duration": "35 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
        "videoUrl": "https://example.com/video15"
      },
      {
        "id": 16,
        "presenter": "Henry Clark",
        "title": "Mastering Agile Project Management",
        "duration": "25 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1534126511673-b6899657816a",
        "videoUrl": "https://example.com/video16"
      },
      {
        "id": 17,
        "presenter": "Charlotte Lewis",
        "title": "Winning Strategies for Business Growth",
        "duration": "50 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2",
        "videoUrl": "https://example.com/video17"
      },
      {
        "id": 18,
        "presenter": "William Young",
        "title": "Leadership in Times of Crisis",
        "duration": "45 Minutes",
        "thumbnail": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
        "videoUrl": "https://example.com/video18"
      }
    ]
}
